import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["input", "results"];

  connect() {
    this.timeout = null;
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.boundHandleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  search() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if (this.inputTarget.value.length >= 2) {
        const form = this.inputTarget.closest("form");
        form.requestSubmit ? form.requestSubmit() : form.submit();
      } else {
        this.clearResults();
      }
    }, 300);
  }

  clearResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.innerHTML = "";
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.clearResults();
    }
  }
}
